const ApiEndPoint = {
    Sewahat: "/sewahat",
    Registration: "/registration",
    Login: "/login",
    VerifyUser:'/verifyUser',
    Verifyotp:"/verifyOtp",
    ForgotPassword: "/forgotPassword",
    ResetPassword: "/resetPassword",
    Profile:'/profile',
    About:'/about',
    Services:'/services',
    Social: "/socialLogin",
    GetUserById: "/getUserById",
    Profile_setup: "/profile_setup",
    GetServices:'/getServices',
    GetVendorById:'/getVendorById',
    ResendOtpForVerification:'/resendOtpForVerification',
    UploadMedia:'/uploadMedia',
    RemoveSamples:'/removeSamples',
    SubmitFeedback: '/submitFeedback',
    RemovePancard:'/removePancard',
    SUBMIT_OTHER_SERVICE: '/submitRequestForService',
    DELETE_SERVICE_RECORD: '/deleteService',
    SKILLS_DATA: '/getAllSkill',
    EDIT_REQUEST: '/editRequest',
    ADD_OTHER_SKILLS: '/addOtherSkills'
  };
  
  Object.freeze(ApiEndPoint);
  export default ApiEndPoint;
  